// import keys from '../../config/locales/keys.json'
// import { Button } from 'antd'
// import { useRouter } from 'next/router'
import Head from 'next/head';
import React from 'react';
import { OffTheShelve } from '../../components/OffTheShelve';
import {
  withPublicWrapper,
  // PublicWrapperProps,
} from '../../components/public/Wrapper/withPublicWrapper';

const OffTheShelvePage = (): JSX.Element => {
  return (
    <>
      <Head>
        <title>Hitch and Hike - Off the shelf</title>
      </Head>
      <OffTheShelve />
    </>
  );
};

export default withPublicWrapper(OffTheShelvePage, { withSider: false, withGoogleOneTap: true });
